import Icon from '@passkeys/ui/icon';
import { useCallback } from 'react';

import useNavigate from '@/ui/hooks/use-navigate';
import { cn } from '@/ui/utils/classnames';

export interface BackButtonProps {
  className?: string;
  onClick?: () => void;
}

function BackButton({ className, onClick }: BackButtonProps) {
  const navigate = useNavigate();
  const navigateBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <button
      onClick={onClick ?? navigateBack}
      type="button"
      className={cn(
        'flex size-8 flex-none items-center justify-center rounded-full border border-solid border-black/6 bg-white shadow-md transition-opacity hover:opacity-50 theme-dark:border-none theme-dark:shadow-none',
        className,
      )}
      data-testid="back-button"
    >
      <Icon name="caret-left" size={24} />
    </button>
  );
}

export default BackButton;
